<template>
  <div id="app">
    <header>
      <h1>CSS Properties Cheat Sheet</h1>
      <input type="search" placeholder="Search color, font-size, box-sizing, …" v-model="filter" autofocus />
    </header>

    

    <main class="grid">
      <nav>
        <ul>
          <li class="" :key="propertiesGroup.name" v-for="(propertiesGroup, key) in properties">
            <strong>{{ key }}</strong>

            <div v-for="group in propertiesGroup">
              <p class="nav-property-group-title">{{ group.name }}</p>
            </div>
          </li>
        </ul>
      </nav>

      
      <section class="content">
        <div>
      
      
      <!-- <table>
        <tbody>
          <tr>
            <td><pre>font-weight: 900</pre></td>
            <td style="font-weight: 900">San Francisco is a font</td>
          </tr>
           <tr>
            <td><pre>font-weight: 700</pre></td>
            <td style="font-weight: 700">San Francisco is a font</td>
          </tr>
           <tr>
            <td><pre>font-weight: 500</pre></td>
            <td style="font-weight: 500">San Francisco is a font</td>
          </tr>
           <tr>
            <td><pre>font-weight: 300</pre></td>
            <td style="font-weight: 300">San Francisco is a font</td>
          </tr>
        </tbody>
      </table>

       <table>
        <tbody>

           <tr>
            <td><pre>font-size: 48px</pre></td>
            <td style="font-size: 48px">San Francisco is a font</td>
          </tr>
           <tr>
            <td><pre>font-size: 32px</pre></td>
            <td style="font-size: 32px">San Francisco is a font</td>
          </tr>
            <tr>
            <td><pre>font-size: 24px</pre></td>
            <td style="font-size: 24px">San Francisco is a font</td>
          </tr>
           <tr>
            <td><pre>font-size: 16px</pre></td>
            <td style="font-size: 16px">San Francisco is a font</td>
          </tr>
        </tbody>
      </table> -->

    </div>
        <section :key="propertiesGroup.name" v-for="(propertiesGroup, key) in properties">
          <!-- <h3 class="properties-group-title">{{ key }}</h3> -->

          <article v-for="group in propertiesGroup">
            <h3 class="property-group-title">{{ group.name }}</h3>

            <ul v-for="properties in group" class="property-list">
              <h3>{{ properties.value }}</h3>
              <li class="property-item" v-for="property in getFilteredProperties(properties)" v-if="property.value">
                <!-- <h4 class="property-name">{{property.name}} </h4> -->
                <details v-if="property.autocomplete" :open="filter != ''">
                  <summary
                    ><span class="property-value"
                      ><span>{{ property.value }} •</span>
                    </span></summary
                  >
                  <ul>
                    <li v-for="value in property.autocomplete">
                      {{ value }}
                    </li>
                  </ul>
                </details>
                <div v-else>
                  <span class="property-value">{{ property.value }} •</span>
                </div>
              </li>
            </ul>
            
          </article>
          <hr style="margin: 4rem 0">
        </section>
      </section>
    </main>
  </div>
</template>

<script>
  import {
    animation,
    appearance,
    behaviour,
    layout,
    flexLayout,
    gridLayout,
    text,
    transforms
  } from "./data/properties/index.js";
  export default {
    name: "App",
    components: {},
    methods: {
      getFilteredProperties(properties) {
        if (this.filter) {
          if (Array.isArray(properties)) {
            return properties.filter((property) => {
              return property.value.includes(this.filter);
            });
          }
        } else {
          return properties;
        }
      }
    },
    data() {
      return {
        filter: "",
        properties: {
          text,
          layout,
          flexLayout,
          gridLayout,
          appearance,
          animation,
          transforms,
          behaviour
        }
      };
    }
  };
</script>

<style lang="scss">
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  #app {
    font-family: system-ui, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    overflow: scroll;
    color: #000;
    padding: 0;
    background: #f5f5f2;
    min-height: 100vh;
  }
  nav {
    background: #f5f5f2;
  }

  header {
    background: white;
    padding: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .grid {
    background: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    display: grid;
    grid-template-columns: 280px 3fr;
  }
  .column article {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }

  @media (min-width: 1024px) {
    .column {
    }
  }

  .properties-group-title {
    text-transform: uppercase;
    position: sticky;
    top: 0;
    background: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 24px;
    letter-spacing: 1px;
  }
  .property-item {
    cursor: default;
    display: inline-block;
  }

  .property-group-title {
    padding: 0.5rem 0;
    color: rgb(201, 16, 36);
    font-size: 16px;

    margin-top: 2rem;
  }
  summary {
    cursor: pointer;
  }

  summary:focus {
    outline: 0;
  }
  summary::-webkit-details-marker {
    display: none;
  }
  details ul {
    margin-bottom: 0.5rem;
    font-size: 13px;
    padding-left: 0.25rem;
    margin-top: -0.125rem;
  }

  .property-value {
    font-weight: normal;
    font-size: 13px;
    padding-right: 8px;
    margin-bottom: 0.125rem;
    display: inline-block;
    font-family: "ia writer mono s", monospace;
  }
  pre {
    font-family: "ia writer mono s", monospace;
  }
  li {
    list-style-type: none;
    
  }

  li + li {
    margin-top: 0.125rem;
  }

  .search-bar {
    display: flex;
    justify-content: center;
  }
  input[type="search"] {
    font-family: "avenir next";
    padding: 0.25rem 1rem;
    border-radius: 100px;
    font-size: 16px;
    width: 300px;
    background: #f5f5f2;
    margin-left: 1rem;
  }
  input[type="search"]:focus {
    outline: none;
    background: #f5f5f2;
    border: 2px solid rgba(0, 0, 0, 0.45);
  }
  h1 {
    font-size: 20px;
  }
  header {
    display: flex;

    width: 100%;
  }

  .nav-property-group-title {
    margin: 0;
    padding: 0.125rem 0rem;
  }
  nav {
    font-size: 13px;
    padding: 1rem;
    font-family: system-ui;
  }
  nav li {
    margin-bottom: 1.5rem;
  }
  .content {
    padding: 2rem 4rem;
    max-width: 900px;
    margin:0 auto;
  }
  .property-list {
    
  }
  table {
    width: 100%
  }
  table td {
    border-bottom: 1px solid #000;
    
  }
</style>
